import { render, staticRenderFns } from "./CardTemplateNewsletters.vue?vue&type=template&id=45f2ae20&scoped=true&"
import script from "./CardTemplateNewsletters.vue?vue&type=script&lang=js&"
export * from "./CardTemplateNewsletters.vue?vue&type=script&lang=js&"
import style0 from "./CardTemplateNewsletters.vue?vue&type=style&index=0&id=45f2ae20&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45f2ae20",
  null
  
)

component.options.__file = "CardTemplateNewsletters.vue"
export default component.exports